export function getStartEndYears(lifespan) {
  const parts = lifespan?.split('–')

  let start = parts?.[0]
  let end = parts?.[1]

  if (start === 'Deceased') start = undefined
  if (end === 'Deceased') end = undefined

  return {
    start: start ? parseInt(start, 10) : undefined,
    end: end ? parseInt(end, 10) : undefined,
  }
}

export function getTotalStartEndYear(items) {
  return items.reduce(
    (acc, item) => {
      const { start, end } = item
      if (start && (start < acc.totalStartYear || !acc.totalStartYear)) acc.totalStartYear = start
      if (end && (end > acc.totalEndYear || !acc.totalEndYear)) acc.totalEndYear = end
      return acc
    },
    { totalStartYear: null, totalEndYear: null }
  )
}

export function getYearStepSize(lowYear, highYear, maxMarkers) {
  let yearStepSize = 10
  while (maxMarkers && (highYear - lowYear) / yearStepSize > maxMarkers) {
    yearStepSize += 10
  }
  return yearStepSize
}

export function getRoundedHighLow(lowYear, highYear, yearStepSize) {
  let roundedLow = lowYear - (lowYear % yearStepSize)
  let roundedHigh = +highYear + (yearStepSize - (highYear % yearStepSize))

  // This is to prevent the first person in the list from being _too_ close to the left side of the timeline
  if (lowYear - roundedLow < yearStepSize / 2) {
    roundedLow -= yearStepSize
  }

  // This is to prevent the last person in the list from being _too_ close to the right side of the timeline
  if (roundedHigh - highYear > yearStepSize / 2) {
    roundedHigh += yearStepSize
  }

  return {
    roundedLow,
    roundedHigh,
  }
}
